import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import { Button, Card, Col, Popconfirm, Row, Table, Tag } from 'antd'
import {
  createAppVersion,
  deleteAppVersion,
  fetchAppVersionList,
  updateAppVersion
} from '../../modules/appVersion'
import { isEmpty } from 'lodash'
import ForceUpdateForm from './ForceUpdateForm'

const ForceUpdate = () => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})

  const { appVersionList } = useSelector(
    (state) => ({
      appVersionList: state.appVersion.appVersionList
    }),
    []
  )

  useDeepEffect(() => {
    async function fetch() {
      await dispatch(fetchAppVersionList())
    }

    fetch()
  }, [])

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }

  const onDelete = async (id) => {
    await dispatch(deleteAppVersion(id))
    await dispatch(fetchAppVersionList())
  }

  const onCancel = async () => {
    await setVisible(false)
    await setFormData({})
  }

  const onOk = async (data) => {
    if (isEmpty(formData)) {
      await dispatch(createAppVersion(data))
    } else {
      await dispatch(updateAppVersion(data))
    }
    await dispatch(fetchAppVersionList())
    await setVisible(false)
  }

  const columns = [
    {
      title: 'User App Version',
      key: 'userAppVersion',
      dataIndex: 'userAppVersion',
      render: (text, record) => <span>{text}</span>
    },
    {
      title: 'Force Update IOS',
      key: 'forceUpdateIOS',
      dataIndex: 'forceUpdateIOS',
      render: (text, record) =>
        text ? (
          <Tag color="green">Enabled</Tag>
        ) : (
          <Tag color="red">Disabled</Tag>
        )
    },
    {
      title: 'Force Update Android',
      key: 'forceUpdateAndroid',
      dataIndex: 'forceUpdateAndroid',
      render: (text, record) =>
        text ? (
          <Tag color="green">Enabled</Tag>
        ) : (
          <Tag color="red">Disabled</Tag>
        )
    },
    {
      title: 'IOS Store',
      key: 'storeUrlIOS',
      dataIndex: 'storeUrlIOS',
      render: (text, record) => <span>{text}</span>
    },
    {
      title: 'Android Store',
      key: 'storeUrlAndroid',
      dataIndex: 'storeUrlAndroid',
      render: (text, record) => <span>{text}</span>
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <Row type="flex" gutter={8}>
          <Col>
            <Button
              type="primary"
              size="small"
              shape="circle"
              icon="edit"
              onClick={(e) => {
                onClick(e, record)
              }}
            />
          </Col>
          <Col>
            <Popconfirm
              title="Confirm Delete?"
              onConfirm={() => {
                onDelete(record.id)
              }}>
              <Button type="danger" size="small" shape="circle" icon="delete" />
            </Popconfirm>
          </Col>
        </Row>
      )
    }
  ]

  const CardHeader = (
    <Row justify="space-between" type="flex">
      <Col>Force Update</Col>
      <Col>
        <Button type="primary" onClick={(e) => onClick(e)}>
          Add
        </Button>
      </Col>
    </Row>
  )

  return (
    <Card title={CardHeader}>
      <Table
        bordered
        dataSource={appVersionList}
        columns={columns}
        rowKey={(record) => {
          return record.id
        }}
      />
      <ForceUpdateForm
        formData={formData}
        visible={visible}
        onCancel={onCancel}
        onOk={onOk}
      />
    </Card>
  )
}

export default ForceUpdate



// WEBPACK FOOTER //
// ./src/pages/ForceUpdate/index.js